(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anbernic-collection-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('anbernic-collection-cards')) {
    customElements.define('anbernic-collection-cards', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.track = this.querySelector('.acc__track');
        this.controls = this.querySelector('.acc__controls');
        this.buttons = [...this.querySelectorAll('[data-step]')];
        if (!this.track || !this.controls) return;
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.controls.hidden = max < 3;
          this.buttons[0].disabled = this.track.scrollLeft <= 2;
          this.buttons[1].disabled = this.track.scrollLeft > max - 3;
        };
        this.move = direction => {
          const card = this.track.querySelector('.acc__item');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
          const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
        };
        this.buttons.forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.step)), options));
        this.track.addEventListener('scroll', this.update, { ...options, passive: true });
        this.track.addEventListener('dragstart', event => event.preventDefault(), options);
        this.track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.dragState = { x: event.clientX, start: this.track.scrollLeft, moved: false };
          this.suppressClick = false;
        }, options);
        this.track.addEventListener('pointermove', event => {
          if (!this.dragState || (event.buttons & 1) === 0) return;
          const distance = event.clientX - this.dragState.x;
          if (!this.dragState.moved && Math.abs(distance) < 6) return;
          this.dragState.moved = true;
          this.track.classList.add('is-dragging');
          if (!this.track.hasPointerCapture(event.pointerId)) this.track.setPointerCapture(event.pointerId);
          event.preventDefault();
          this.track.scrollLeft = this.dragState.start - distance;
        }, options);
        const finishDrag = event => {
          if (!this.dragState) return;
          this.suppressClick = this.dragState.moved && event.type !== 'pointercancel';
          this.dragState = null;
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
          this.update();
        };
        this.track.addEventListener('pointerup', finishDrag, options);
        this.track.addEventListener('pointercancel', finishDrag, options);
        this.track.addEventListener('click', event => {
          if (!this.suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
        }, { ...options, capture: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const card = [...this.track.children].find(item => item.dataset.blockId === event.detail?.blockId);
          if (card) this.track.scrollTo({ left: card.offsetLeft - 4, behavior: 'auto' });
        }, options);
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.dragState = null;
        this.track?.classList.remove('is-dragging');
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anbernic-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('invalid', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('.anbernic-footer__newsletter-form input[type="email"]')) return;
    input.setCustomValidity('');
    if (input.validity.valueMissing) {
      input.setCustomValidity('Veuillez saisir votre adresse e-mail.');
    } else if (input.validity.typeMismatch) {
      input.setCustomValidity('Veuillez saisir une adresse e-mail valide.');
    }
  }, true);

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.matches('.anbernic-footer__newsletter-form input[type="email"]')) {
      input.setCustomValidity('');
    }
  });

  const revealNewsletterSuccess = () => {
    const message = document.querySelector('[data-newsletter-success]');
    if (!(message instanceof HTMLElement)) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.requestAnimationFrame(() => {
      message.focus({ preventScroll: true });
      message.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'center'
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealNewsletterSuccess, { once: true });
  } else {
    revealNewsletterSuccess();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.anbernic-footer__accordion-trigger');
    if (!trigger) return;

    const footer = trigger.closest('.anbernic-footer--mobile-accordion');
    if (!footer || !window.matchMedia('(max-width: 749px)').matches) return;

    const willOpen = trigger.getAttribute('aria-expanded') !== 'true';
    const singleOpen = footer.dataset.mobileSingleAccordion !== 'false';

    if (willOpen && singleOpen) {
      footer.querySelectorAll('.anbernic-footer__accordion-trigger[aria-expanded="true"]').forEach((otherTrigger) => {
        if (otherTrigger !== trigger) otherTrigger.setAttribute('aria-expanded', 'false');
      });
    }

    trigger.setAttribute('aria-expanded', String(willOpen));
  });

  if (!customElements.get('anbernic-footer-localization')) {
    customElements.define('anbernic-footer-localization', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-enhanced')) return;
        this.addEventListener('change', (event) => {
          if (event.target instanceof HTMLSelectElement && event.target.form) {
            event.target.form.requestSubmit();
          }
        });
        this.setAttribute('data-enhanced', '');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anbernic-system-tiles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('anbernic-system-tiles')) {
    customElements.define('anbernic-system-tiles', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.track = this.querySelector('.ast__grid');
        if (!this.track) return;
        this.mobileQuery = matchMedia('(max-width: 699px)');
        this.suppressClick = false;
        this.finishDrag = event => {
          if (!this.dragState || (event && event.pointerId !== this.dragState.pointerId)) return;
          const { pointerId, moved } = this.dragState;
          this.suppressClick = moved && event?.type === 'pointerup';
          this.dragState = null;
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture(pointerId)) this.track.releasePointerCapture(pointerId);
        };
        this.update = () => {
          const canScroll = this.mobileQuery.matches && this.track.scrollWidth > this.track.clientWidth + 2;
          this.track.tabIndex = canScroll ? 0 : -1;
          if (!canScroll) this.finishDrag();
        };
        this.scrollToItem = item => {
          const left = item.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
          this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        this.track.addEventListener('pointerdown', event => {
          this.suppressClick = false;
          if (!this.mobileQuery.matches || event.pointerType !== 'mouse' || event.button !== 0 || this.track.scrollWidth <= this.track.clientWidth + 2) return;
          this.finishDrag();
          this.dragState = { pointerId: event.pointerId, x: event.clientX, start: this.track.scrollLeft, moved: false };
        }, options);
        this.track.addEventListener('pointermove', event => {
          if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;
          if ((event.buttons & 1) === 0) { this.finishDrag(event); return; }
          const distance = event.clientX - this.dragState.x;
          if (!this.dragState.moved && Math.abs(distance) < 6) return;
          this.dragState.moved = true;
          this.track.classList.add('is-dragging');
          if (!this.track.hasPointerCapture(event.pointerId)) this.track.setPointerCapture(event.pointerId);
          event.preventDefault();
          this.track.scrollLeft = this.dragState.start - distance;
        }, options);
        this.track.addEventListener('pointerup', this.finishDrag, options);
        this.track.addEventListener('pointercancel', this.finishDrag, options);
        this.track.addEventListener('lostpointercapture', this.finishDrag, options);
        this.track.addEventListener('dragstart', event => {
          if (this.mobileQuery.matches) event.preventDefault();
        }, options);
        this.track.addEventListener('click', event => {
          if (!this.suppressClick || event.detail === 0) return;
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
        }, { ...options, capture: true });
        this.track.addEventListener('keydown', event => {
          if (!this.mobileQuery.matches || event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const items = [...this.track.querySelectorAll('.ast__item')];
          const offset = this.track.getBoundingClientRect().left;
          const position = item => item.getBoundingClientRect().left - offset;
          let item;
          if (event.key === 'Home') item = items[0];
          else if (event.key === 'End') item = items.at(-1);
          else if (event.key === 'ArrowRight') item = items.find(candidate => position(candidate) > 2);
          else item = items.findLast(candidate => position(candidate) < -2);
          if (item) this.scrollToItem(item);
        }, options);
        document.addEventListener('shopify:block:select', event => {
          if (!this.mobileQuery.matches) return;
          const item = [...this.track.children].find(candidate => candidate.dataset.blockId === event.detail?.blockId);
          if (item) this.scrollToItem(item);
        }, options);
        this.mobileQuery.addEventListener('change', this.update, options);
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.finishDrag?.();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auto-tech-specs"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'anbernic-auto-specs';
  if (customElements.get(tag)) return;
  let nextTableId = 0;

  const normalized = value => String(value ?? '').normalize('NFKC').trim().toLocaleLowerCase()
    .replace(/[：:]\s*$/, '').replace(/\s+/g, ' ');

  const folded = value => normalized(value).normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[’‘`´]/g, "'")
    .replace(/[／\/|·•]+/g, ' ')
    .replace(/[-–—_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  /*
   * 多语言参数识别：
   * 1) 不再只依赖一份固定词表，而是按“参数类别”做关键词/短语匹配；
   * 2) 已覆盖 EN/FR/DE/PT/IT/ES/NL/PL/RU/UK/KO/ZH/JA 等常见表达；
   * 3) 即使遇到未列出的语言，也会继续通过参数值（分辨率、mAh、芯片、容量等）做兜底判断。
   */
  const labelPatterns = {
    color: [
      /\bcolou?rs?\b/i, /\bcouleurs?\b/i, /\bfarben?\b/i, /\bcores?\b/i,
      /\bcolou?re?s?\b/i, /\bcolores?\b/i, /\bkleur(?:en)?\b/i, /\bkolor(?:y)?\b/i,
      /\bцвет(?:а|ы)?\b/i, /\bколір(?:и)?\b/i, /색상|색깔/i, /颜色|顏色|カラー|色/i
    ],
    screen: [
      /\bscreen\b/i, /\bdisplay\b/i, /\becran\b/i, /\bbildschirm\b/i, /\btela\b/i,
      /\bschermo\b/i, /\bpantalla\b/i, /\bscherm\b/i, /\bekran\b/i,
      /\bэкран\b/i, /\bдиспле[йя]\b/i, /\bекран\b/i, /화면|디스플레이/i, /屏幕|螢幕|画面|スクリーン|ディスプレイ/i
    ],
    cpu: [
      /(^|\b)cpu(\b|$)/i, /\bprocessor\b/i, /\bprocesseur\b/i, /\bprozessor\b/i,
      /\bprocessador\b/i, /\bprocessore\b/i, /\bprocesador\b/i, /\bprocessor(?:en)?\b/i,
      /\bпроцессор\b/i, /\bпроцесор\b/i, /프로세서|칩셋/i, /处理器|處理器|プロセッサー/i
    ],
    gpu: [/(^|\b)gpu(\b|$)/i, /graphics? processor/i, /grafikprozessor/i, /processeur graphique/i, /processore grafico/i, /procesador grafico/i, /그래픽/i, /图形处理器|圖形處理器/i],
    memory: [
      /(^|\b)ram(\b|$)/i, /(^|\b)rom(\b|$)/i, /\bmemory\b/i, /\bstorage\b/i, /\bmemoire\b/i,
      /\bstockage\b/i, /\barbeitsspeicher\b/i, /\bspeicher\b/i, /\bmemoria\b/i, /\barchiviazione\b/i,
      /\balmacenamiento\b/i, /\bopslag\b/i, /\bpamiec\b/i, /\bпамять\b/i, /\bпам'ять\b/i,
      /메모리|저장/i, /内存|記憶體|存储|儲存|メモリ|ストレージ/i
    ],
    system: [
      /\boperating system\b/i, /(^|\b)os(\b|$)/i, /\bsysteme d'exploitation\b/i, /\bbetriebssystem\b/i,
      /\bsistema operativo\b/i, /\bsistema operacional\b/i, /\bbesturingssysteem\b/i, /\bsystem operacyjny\b/i,
      /\bоперационная система\b/i, /\bопераційна система\b/i, /운영체제/i, /系统|系統|システム/i
    ],
    games: [
      /\bgames?\b/i, /\bjeux\b/i, /\bspiele\b/i, /\bjogos\b/i, /\bgiochi\b/i, /\bjuegos\b/i,
      /\bgames? support\b/i, /\bgry\b/i, /\bигры\b/i, /\bігри\b/i, /게임/i, /游戏|遊戲|ゲーム/i
    ],
    language: [
      /\blanguages?\b/i, /\blangues?\b/i, /\bsprache\b/i, /\bidioma(?:s)?\b/i, /\blingua(?:e)?\b/i,
      /\btalen?\b/i, /\bjezyk\b/i, /\bязык\b/i, /\bмова\b/i, /언어/i, /语言|語言|言語/i
    ],
    speaker: [
      /\bspeakers?\b/i, /\baudio\b/i, /\bhaut parleurs?\b/i, /\blautsprecher\b/i, /\balto falante\b/i,
      /\baltoparlant[ei]\b/i, /\baltavoz(?:es)?\b/i, /\bluidspreker(?:s)?\b/i, /\bglosnik(?:i)?\b/i,
      /\bдинамик(?:и)?\b/i, /스피커|오디오/i, /扬声器|揚聲器|スピーカー/i
    ],
    battery: [
      /\bbatter(?:y|ies)\b/i, /\bbatterie\b/i, /\bakku\b/i, /\bbateria\b/i, /\bbatteria\b/i,
      /\bbatterij\b/i, /\bbateria\b/i, /\bаккумулятор\b/i, /\bбатаре[яи]\b/i, /배터리/i, /电池|電池|バッテリー/i
    ],
    connectivity: [
      /\bwi ?-?fi\b/i, /\bwifi\b/i, /\bbluetooth\b/i, /\bconnectiv/i, /\bconnexion/i, /\bconnettivit/i,
      /\bconectividad\b/i, /\bconectividade\b/i, /\bverbinding\b/i, /\blacznosc\b/i, /연결|와이파이|블루투스/i, /连接|連接|接続/i
    ],
    accessories: [
      /\baccessor(?:y|ies)\b/i, /\baccessoires?\b/i, /\bzubehor\b/i, /\bacessorios?\b/i, /\baccessori\b/i,
      /\baccesorios?\b/i, /\bakcesoria\b/i, /\bаксессуар/i, /액세서리/i, /配件|付属品|アクセサリ/i
    ],
    appearance: [/\bappearance\b/i, /\bapparence\b/i, /\baussehen\b/i, /\baparencia\b/i, /\baspetto\b/i, /\b wyglad\b/i, /외관/i, /外观|外觀/i],
    dimensions: [
      /\bdimensions?\b/i, /\babmessungen\b/i, /\bdimensoes\b/i, /\bdimensioni\b/i, /\bdimensiones\b/i,
      /\bafmetingen\b/i, /\bwymiary\b/i, /\bразмеры\b/i, /\bрозміри\b/i, /크기|치수/i, /尺寸|サイズ|本体サイズ/i
    ],
    weight: [/\bweight\b/i, /\bpoids\b/i, /\bgewicht\b/i, /\bpeso\b/i, /\bgewicht\b/i, /\bwaga\b/i, /\bвес\b/i, /\bвага\b/i, /무게/i, /重量|重さ/i],
    ports: [/\bports?\b/i, /\banschluss(?:e)?\b/i, /\bporte\b/i, /\bpuertos?\b/i, /\bportas?\b/i, /\bpoorten?\b/i, /포트/i, /接口|ポート/i],
    model: [/\bmodels?\b/i, /\bmodele\b/i, /\bmodelo\b/i, /\bmodell\b/i, /\bmodello\b/i, /\bмодель\b/i, /모델/i, /型号|型號|機種|モデル/i],
    parameter: [/\bparameters?\b/i, /\bparametres?\b/i, /\bparameter\b/i, /\bparametri\b/i, /\bparametros?\b/i, /\bпараметр/i, /매개변수|사양/i, /参数|參數/i]
  };

  function labelKind(label) {
    const raw = normalized(label);
    const key = folded(label);
    if (!raw) return '';
    for (const [kind, patterns] of Object.entries(labelPatterns)) {
      if (patterns.some(pattern => pattern.test(raw) || pattern.test(key))) return kind;
    }
    return '';
  }

  function valueKind(value) {
    const raw = normalized(value);
    if (!raw) return '';
    if (/\d+(?:[.,]\d+)?\s*mAh\b/i.test(raw)) return 'battery';
    if (/\d{3,4}\s*[×x*]\s*\d{3,4}/i.test(raw) || /\d+(?:[.,]\d+)?\s*(?:inch(?:es)?|pouces?|zoll|pollici|pulgadas?|polegadas?|英寸|インチ)\b/i.test(raw)) return 'screen';
    if (/\b(?:snapdragon|dimensity|helio|rockchip|mediatek|unisoc|allwinner)\b/i.test(raw) || /\b(?:rk\d{4}[a-z0-9]*|h\d{3}[a-z0-9]*|t\d{3}[a-z0-9]*)\b/i.test(raw)) return 'cpu';
    if (/\b\d+(?:[.,]\d+)?\s*(?:gb|gib|tb|tib)\b/i.test(raw) && /[+／/]|ram|rom|storage|memory|memoria|memoire|speicher|archiviazione|almacenamiento/i.test(raw)) return 'memory';
    return '';
  }

  const known = label => Boolean(labelKind(label));
  const richOrInteractive = 'img, picture, video, audio, iframe, svg, canvas, form, input, button, script, style, object, embed, details';
  const specHeading = /spec(?:ification|ifications|ifiche|ifiche tecniche)|technical|caracteristiques|fiche technique|technische|especifica(?:c|ç)(?:ao|oes|ão|ões)|especificaciones|caracteristicas tecnicas|dati tecnici|scheda tecnica|technische daten|specificaties|specyfikacja|характеристик|технічн|기술 사양|规格|規格|技术参数|技術仕様|製品仕様/i;
  const dimensionValue = /^(length|width|height|weight|longueur|largeur|hauteur|poids|lange|breite|hohe|gewicht|comprimento|largura|altura|peso|lunghezza|larghezza|altezza|peso|longitud|ancho|altura|gewicht|lengte|breedte|hoogte|dlugosc|szerokosc|wysokosc|waga|长|長|宽|寬|高|重量|幅|高さ|奥行|重さ)\s*[:：]?\s*\d/i;
  const capacityPair = /^\d+(?:[.,]\d+)?\s*(?:[GMT](?:B|O)?|GiB|TiB)\s*[+／/]\s*\d+(?:[.,]\d+)?\s*(?:[GMT](?:B|O)?|GiB|TiB)$/i;
  const isConfigurationLabel = label => labelKind(label) === 'memory' && /(?:ram|rom|memory|storage|memoire|stockage|memoria|archiviazione|almacenamiento|speicher|内存|記憶體|存储|儲存|メモリ|ストレージ)/i.test(normalized(label));
  const isColorLabel = label => labelKind(label) === 'color';
  const isMatrixLabel = label => ['model', 'parameter', 'color'].includes(labelKind(label));

  function logicalRows(table) {
    const sourceRows = [...table.rows];
    const records = [];
    let active = [];
    let rowGroup = null;
    let spanWidth = null;
    for (const row of sourceRows) {
      if (row.parentElement !== rowGroup) {
        active = [];
        spanWidth = null;
        rowGroup = row.parentElement;
      }
      const inherited = active.some(slot => slot?.remaining > 0);
      const grid = active.map(slot => slot?.remaining > 0 ? slot.cell : null);
      for (const slot of active) if (slot?.remaining > 0) slot.remaining--;
      let column = 0;
      for (const cell of row.cells) {
        while (grid[column]) column++;
        const width = cell.colSpan;
        if (column + width > 20) return null;
        const remainingGroupRows = [...rowGroup.rows].length - [...rowGroup.rows].indexOf(row);
        const height = cell.rowSpan === 0 ? remainingGroupRows : Math.min(cell.rowSpan, remainingGroupRows);
        for (let offset = 0; offset < width; offset++) {
          if (grid[column + offset]) return null;
          grid[column + offset] = cell;
          active[column + offset] = {cell, remaining: height - 1};
        }
        column += width;
      }
      while (grid.length && !grid[grid.length - 1]) grid.pop();
      if (!grid.length) continue;
      if (grid.some(cell => !cell)) return null;
      if (inherited && grid.length !== spanWidth) return null;
      spanWidth = active.some(slot => slot?.remaining > 0) ? grid.length : null;
      if (!row.cells.length && inherited) continue;
      const cells = [...new Set(grid)];
      const previous = records[records.length - 1];
      if (previous && previous.cells[0] === cells[0] && cells.length > 1) {
        const freshValues = cells.slice(1).filter(cell => [...row.cells].includes(cell));
        if (freshValues.length) {
          previous.valueGroups.push(cells.slice(1));
          previous.grids.push(grid);
        }
      } else {
        records.push({node: row, cells, grids: [grid], valueGroups: cells.length > 1 ? [cells.slice(1)] : []});
      }
    }
    return records;
  }

  function canCombineValues(row) {
    const label = normalized(row.cells[0].textContent);
    return row.valueGroups.every(group => {
      if (group.length <= 1) return true;
      if (group.some(cell => cell.tagName === 'TH')) return false;
      const values = group.map(cell => normalized(cell.textContent));
      if (values.every(value => dimensionValue.test(value))) return true;
      if (isConfigurationLabel(label) && values.every(value => capacityPair.test(value))) return true;
      return isColorLabel(label) && values.every(value => value.length > 0 && value.length <= 120);
    });
  }

  function measureKind(cell) {
    const value = normalized(cell.textContent);
    if (!/\d/.test(value)) return '';
    return /^(dimensions?|size|尺寸)/i.test(value) ? 'dimensions'
      : /^(poids|weight|gewicht|peso|重量|重さ)/i.test(value) ? 'weight'
      : dimensionValue.test(value) ? value.split(/[\s:：\d]/)[0] : '';
  }

  function matrixData(rows) {
    const header = rows.find(row => row.cells.length >= 2);
    if (!header || !isMatrixLabel(header.cells[0].textContent)) return null;
    const grid = header.grids[0];
    const columns = [];
    const seen = new Set([header.cells[0]]);
    grid.forEach((cell, start) => {
      if (!seen.has(cell) && cell.textContent.trim()) {
        columns.push({cell, start, end: grid.length});
        seen.add(cell);
      }
    });
    if (columns.length < 2 || columns.length > 4) return null;
    columns.forEach((column, index) => { column.end = columns[index + 1]?.start ?? grid.length; });
    if (rows.some(row => row.cells.length > 1 && row.grids.some(rowGrid => rowGrid.length !== grid.length))) return null;
    return {header, columns};
  }

  function cleanClone(node) {
    const copy = node.cloneNode(true);
    if (copy.nodeType === Node.ELEMENT_NODE) {
      for (const el of [copy, ...copy.querySelectorAll('*')]) {
        for (const attr of [...el.attributes]) {
          if (attr.name.startsWith('on') || ['style', 'class', 'id', 'align', 'valign', 'bgcolor'].includes(attr.name) || (['width', 'height'].includes(attr.name) && el.tagName !== 'IMG')) {
            el.removeAttribute(attr.name);
          }
        }
      }
      const nestedTables = [copy, ...copy.querySelectorAll('table')].filter(el => el.tagName === 'TABLE').reverse();
      for (const table of nestedTables) {
        if (table.rows.length === 1 && table.rows[0].cells.length === 1) {
          const fragment = document.createDocumentFragment();
          fragment.append(...table.rows[0].cells[0].childNodes);
          if (table === copy) return fragment;
          table.replaceWith(fragment);
        }
      }
    }
    return copy;
  }

  function appendContents(target, original) {
    for (const child of original.childNodes) target.append(cleanClone(child));
  }

  function plainLines(element) {
    const copy = element.cloneNode(true);
    copy.querySelectorAll('br').forEach(br => br.replaceWith('\n'));
    return copy.textContent.split(/\n/).map(line => line.trim()).filter(Boolean);
  }

  function linePair(line) {
    const match = line.match(/^([^:：\n]{1,64})\s*[:：]\s*(.+)$/u);
    if (!match || /https?|mailto/i.test(match[1])) return null;
    return { label: match[1].trim(), value: match[2].trim() };
  }

  const legacyPrefix = /^(?:[-‐‑‒–—−]+|[•●▪◦*])\s*/u;
  const legacyNames = new Set([
    'wifi/bluetooth', 'wi-fi/bluetooth', 'fonction', 'multimédia réseau', 'network multimedia',
    'matériau', 'material', 'jeu', 'charge', 'charging', 'dissipation de puissance', 'power dissipation', 'apparence'
  ]);
  const legacyKnown = label => known(label) || legacyNames.has(normalized(label));
  const legacyFunctions = new Set(['autres fonctions', 'other functions']);
  const legacyEmulatorNote = text =>
    /^(?:prise en charge|prend en charge|supports?)\b/i.test(text)
    && /\d/.test(text) && /[ée]mulateurs?|emulators?/i.test(text);
  const legacyHeading = text => specHeading.test(text) || /^description de la RG\d+[a-z0-9]*$/i.test(text);
  const legacyNoteContinuation = (entry, text) => entry?.kind === 'note'
    && !entry.continuations.length && legacyEmulatorNote(entry.text)
    && /^Permet aux utilisateurs de télécharger des jeux dans les formats correspondants[.!]?$/i.test(text);
  const legacyContinuation = (entry, text) => entry?.kind === 'pair'
    && legacyFunctions.has(normalized(entry.label))
    && !entry.continuations.length && /[\/／]\s*$/.test(entry.value)
    && /^(?:r[eé]glages?\b|power[- ]saving\b|energy[- ]saving\b|screen brightness\b)/i.test(text);

  function nextPlainSibling(node) {
    const sibling = node.nextElementSibling;
    for (let between = node.nextSibling; between && between !== sibling; between = between.nextSibling) {
      if (between.nodeType === Node.TEXT_NODE && between.textContent.trim()) return null;
    }
    return sibling;
  }

  function previousPlainSibling(node) {
    const sibling = node.previousElementSibling;
    for (let between = node.previousSibling; between && between !== sibling; between = between.previousSibling) {
      if (between.nodeType === Node.TEXT_NODE && between.textContent.trim()) return null;
    }
    return sibling;
  }

  function tableData(table) {
    if (table.id || table.querySelector('[id], video, audio, iframe, svg, canvas, form, input, button, script, style, object, embed, details')) return null;
    if ([...table.querySelectorAll('table')].some(nested => nested.rows.length !== 1 || nested.rows[0].cells.length !== 1)) return null;
    const rows = logicalRows(table);
    if (!rows || rows.length < 2) return null;
    const matrix = matrixData(rows);
    if (!matrix && rows.some(row => !canCombineValues(row))) return null;
    const pairs = rows.filter(row => row.cells.length >= 2);
    if (pairs.some(row => !row.cells[0].textContent.trim() || row.cells[0].textContent.trim().length > 90)) return null;
    if (pairs.length < 2) return null;
    if (table.caption?.querySelector('a')) return null;
    const titleRow = !table.caption && rows[0].cells.length === 1 && !rows[0].node.querySelector('a') ? rows[0] : null;
    const heading = table.caption?.textContent || titleRow?.cells[0].textContent || '';
    const matchCount = pairs.filter(row => known(row.cells[0].textContent)).length;
    const valueMatchCount = pairs.filter(row => valueKind(row.cells.slice(1).map(cell => cell.textContent).join(' '))).length;
    const looksLikeSpecHeading = specHeading.test(folded(heading));
    if (matchCount < 2
      && !(matchCount >= 1 && looksLikeSpecHeading)
      && !(valueMatchCount >= 2 && looksLikeSpecHeading)
      && !(valueMatchCount >= 3 && pairs.length >= 4)) return null;
    return { rows, heading, titleRow, matrix };
  }

  class AutoSpecs extends HTMLElement {
    static get observedAttributes() {
      return ['data-mobile-collapse', 'data-mobile-limit', 'data-expand-label', 'data-collapse-label', 'data-design', 'data-show-highlights', 'data-default-tab', 'data-overview-label', 'data-details-label'];
    }

    attributeChangedCallback(name) {
      if (!this.isConnected) return;
      if (name === 'data-default-tab') this.querySelectorAll('.as-card').forEach(card => { card._asActiveTab = null; card._asPresentationSignature = null; });
      if (['data-design', 'data-show-highlights', 'data-default-tab', 'data-overview-label', 'data-details-label'].includes(name)) this.enhance();
      else this.syncCollapse();
    }

    connectedCallback() {
      this.mobileQuery ||= window.matchMedia('(max-width: 749px)');
      this.onViewportChange ||= () => {
        this.querySelectorAll('.as-table-wrap').forEach(wrap => wrap.getAnimations().forEach(animation => animation.cancel()));
        this.syncCollapse();
      };
      this.mobileQuery.addEventListener('change', this.onViewportChange);
      this.observer ||= new MutationObserver(() => {
        if (this.queued) return;
        this.queued = true;
        queueMicrotask(() => {
          this.queued = false;
          if (this.isConnected) this.enhance();
        });
      });
      this.enhance();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mobileQuery?.removeEventListener('change', this.onViewportChange);
      this.querySelectorAll('.as-table-wrap').forEach(wrap => wrap.getAnimations().forEach(animation => animation.cancel()));
    }

    syncCollapse() {
      const enabled = this.dataset.mobileCollapse !== 'false';
      const requested = Number.parseInt(this.dataset.mobileLimit || '10', 10);
      const limit = Number.isFinite(requested) ? Math.max(1, requested) : 10;
      const mobile = this.mobileQuery?.matches ?? window.matchMedia('(max-width: 749px)').matches;
      for (const card of this.querySelectorAll('.as-card')) {
        const table = card.querySelector('.as-table');
        if (!table) continue;
        const rows = [...table.rows];
        const parameters = rows.filter(row => row.querySelector('th[scope="row"]'));
        const hasMore = parameters.length > limit;
        let button = card.querySelector('.as-toggle');
        if (hasMore && enabled && !button) {
          button = document.createElement('button');
          button.type = 'button';
          button.className = 'as-toggle';
          const label = document.createElement('span');
          label.className = 'as-toggle-label';
          const arrow = document.createElement('span');
          arrow.className = 'as-toggle-arrow';
          arrow.setAttribute('aria-hidden', 'true');
          button.append(label, arrow);
          if (!table.id) {
            do { table.id = `as-spec-table-${++nextTableId}`; }
            while (document.getElementById(table.id) && document.getElementById(table.id) !== table);
          }
          button.setAttribute('aria-controls', table.id);
          button.addEventListener('click', () => {
            const expanded = card.dataset.mobileExpanded === 'true';
            const wrap = card.querySelector('.as-table-wrap');
            const previousHeight = wrap.getBoundingClientRect().height;
            const hiddenRows = [...table.rows].filter(row => row.hidden);
            wrap.getAnimations().forEach(animation => animation.cancel());
            [...table.rows].forEach(row => row.getAnimations().forEach(animation => animation.cancel()));
            card.dataset.mobileExpanded = String(!expanded);
            this.syncCollapse();
            if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
              wrap.animate([
                {height: `${previousHeight}px`},
                {height: `${wrap.getBoundingClientRect().height}px`}
              ], {duration: 280, easing: 'cubic-bezier(.22, .68, 0, 1)'});
              if (!expanded) hiddenRows.forEach((row, index) => row.animate([
                {opacity: 0}, {opacity: 1}
              ], {duration: 220, delay: Math.min(index, 6) * 18, fill: 'backwards', easing: 'ease-out'}));
            }
            if (expanded) requestAnimationFrame(() => {
              const rect = button.getBoundingClientRect();
              if (rect.top < 0 || rect.bottom > window.innerHeight) button.scrollIntoView({block: 'nearest'});
            });
          });
          card.append(button);
        }
        const active = enabled && mobile && hasMore;
        const collapsed = active && card.dataset.mobileExpanded !== 'true';
        const boundary = hasMore ? rows.indexOf(parameters[limit - 1]) : rows.length;
        rows.forEach((row, index) => { row.hidden = collapsed && index > boundary; });
        if (button) {
          button.hidden = !active || card.dataset.activeTab === 'overview';
          button.setAttribute('aria-expanded', String(!collapsed));
          const label = collapsed
            ? this.dataset.expandLabel || 'Afficher tous les paramètres'
            : this.dataset.collapseLabel || 'Réduire';
          const text = button.querySelector('.as-toggle-label');
          if (text.textContent !== label) text.textContent = label;
        }
      }
    }

    highlightKind(label, value = '') {
      const kind = labelKind(label);
      if (kind === 'screen') return 'screen';
      if (kind === 'cpu') return 'cpu';
      if (kind === 'memory') return 'memory';
      if (kind === 'battery') return 'battery';
      const inferred = valueKind(value);
      return ['screen','cpu','memory','battery'].includes(inferred) ? inferred : '';
    }

    summaryFor(row, kind) {
      const label = row.cells[0].textContent.trim();
      const parts = [...row.cells[1].querySelectorAll('.as-value-part')];
      const values = (parts.length ? parts : [row.cells[1]]).map(node => node.textContent.trim()).filter(Boolean);
      let summary = values;
      let sub = '';
      if (values.length === 1) {
        const raw = values[0];
        if (kind === 'screen') {
          const sizes = [...raw.matchAll(/\d+(?:[.,]\d+)?(?:\s*-\s*|\s*)(?:inch(?:es)?|pouces?|Zoll|polegadas?|pulgadas?|英寸|インチ)/gi)];
          if (sizes.length === 1) {
            summary = [sizes[0][0]];
            const resolution = raw.match(/\d{3,4}\s*[×x*]\s*\d{3,4}/i);
            sub = resolution?.[0] || '';
          }
        } else if (kind === 'cpu') {
          const snapdragon = raw.match(/Snapdragon\s+([^()，,;；]+?)(?=\s*\(|\s*（|$)/i);
          const chip = raw.match(/\b(?:RK\d{4}[A-Z0-9]*|H\d{3}[A-Z0-9]*|T\d{3}[A-Z0-9]*|Dimensity\s+\d+|Helio\s+G\d+)\b/i);
          if (snapdragon) {
            summary = [snapdragon[1].trim()];
            sub = raw.match(/(?:Qualcomm\s+)?Snapdragon/i)?.[0] || '';
          } else if (chip) summary = [chip[0]];
        } else if (kind === 'battery') {
          const capacities = [...raw.matchAll(/\d+(?:[.,]\d+)?\s*mAh\b/gi)];
          if (capacities.length === 1) {
            summary = [capacities[0][0]];
            sub = raw.match(/(?:autonomie[^,;.]{0,60}?heures?|lasting[^,;.]{0,50}?hours?|up to\s+\d+(?:[.,]\d+)?\s*hours?)/i)?.[0] || '';
          }
        }
      }
      return {label, values: summary, sub, kind};
    }

    buildHighlight(summary) {
      const tile = document.createElement('div');
      tile.className = 'as-highlight';
      tile.dataset.kind = summary.kind;
      const head = document.createElement('div');
      head.className = 'as-highlight-head';
      const label = document.createElement('span');
      label.textContent = summary.label;
      const icon = document.createElement('span');
      icon.className = `as-highlight-icon as-highlight-icon--${summary.kind}`;
      icon.setAttribute('aria-hidden','true');
      head.append(label,icon);
      const value = document.createElement('div');
      value.className = 'as-highlight-value';
      value.classList.toggle('as-highlight-value--long', summary.values.some(text => text.length > 22));
      summary.values.forEach(text => {
        const part = document.createElement('div');
        part.textContent = text;
        value.append(part);
      });
      tile.append(head,value);
      if (summary.sub) {
        const sub = document.createElement('div');
        sub.className = 'as-highlight-sub';
        sub.textContent = summary.sub;
        tile.append(sub);
      }
      return tile;
    }

    syncPresentation() {
      const design = ['dossier','manual','pixel'].includes(this.dataset.design) ? this.dataset.design : 'classic';
      for (const card of this.querySelectorAll('.as-card')) {
        card.dataset.design = design;
        const table = card.querySelector('.as-table');
        const wrap = card.querySelector('.as-table-wrap');
        const rows = [...table.rows].filter(row => row.querySelector('th[scope="row"]'));
        const overviewLabel = this.dataset.overviewLabel?.trim() || 'L’essentiel';
        const detailsLabel = this.dataset.detailsLabel?.trim() || 'Tous les paramètres';
        const signature = [design,this.dataset.showHighlights,this.dataset.defaultTab,overviewLabel,detailsLabel,table.textContent].join('\u001f');
        if (card._asPresentationSignature === signature) continue;
        card._asPresentationSignature = signature;
        card.querySelector('.as-view-tabs')?.remove();
        card.querySelector('.as-overview')?.remove();
        wrap.hidden = false;
        if (wrap.getAttribute('role') === 'tabpanel') {
          wrap.removeAttribute('role');
          wrap.removeAttribute('aria-labelledby');
        }
        delete card.dataset.activeTab;
        const collapse = card.querySelector('.as-toggle');
        if (collapse) collapse.hidden = true;
        if (design === 'classic' || this.dataset.showHighlights === 'false' || table.classList.contains('as-table--matrix')) continue;
        const eligible = rows.filter(row => row.cells.length === 2 && !row.cells[1].querySelector('img, picture, table, a') && row.cells[1].textContent.trim());
        const chosen = [];
        for (const kind of ['screen','cpu','memory','battery']) {
          const candidates = eligible.filter(row => this.highlightKind(row.cells[0].textContent, row.cells[1].textContent) === kind);
          const combined = candidates.find(row => isConfigurationLabel(row.cells[0].textContent));
          const ram = candidates.find(row => normalized(row.cells[0].textContent) === 'ram');
          const row = combined || ram || candidates[0];
          if (row) chosen.push({row, summary:this.summaryFor(row,kind)});
        }
        if (chosen.length < 2) continue;
        if (!table.id) {
          do { table.id = `as-spec-table-${++nextTableId}`; }
          while (document.getElementById(table.id) && document.getElementById(table.id) !== table);
        }
        const overview = document.createElement('div');
        overview.className = 'as-overview';
        overview.id = `${table.id}-overview`;
        overview.setAttribute('role','tabpanel');
        const highlights = document.createElement('div');
        highlights.className = 'as-highlights';
        highlights.dataset.count = String(chosen.length);
        highlights.style.setProperty('--as-highlight-columns',String(chosen.length));
        chosen.forEach(item => highlights.append(this.buildHighlight(item.summary)));
        overview.append(highlights);
        const used = new Set(chosen.map(item => item.row));
        const basics = eligible.filter(row => !used.has(row) && row.cells[1].textContent.trim().length <= 160).slice(0,4);
        if (basics.length) {
          const list = document.createElement('dl');
          list.className = 'as-overview-list';
          basics.forEach(row => {
            const item = document.createElement('div');
            const name = document.createElement('dt');
            name.textContent = row.cells[0].textContent.trim();
            name.dataset.parameterIndex = String(rows.indexOf(row) + 1).padStart(2,'0');
            const value = document.createElement('dd');
            const parts = [...row.cells[1].querySelectorAll('.as-value-part')];
            value.textContent = (parts.length ? parts : [row.cells[1]]).map(node => node.textContent.trim()).join(' · ');
            item.append(name,value);
            list.append(item);
          });
          overview.append(list);
        }
        const nav = document.createElement('div');
        nav.className = 'as-view-tabs';
        nav.setAttribute('role','tablist');
        nav.setAttribute('aria-label',card.querySelector('.as-title')?.textContent || detailsLabel);
        const tabs = [overviewLabel,detailsLabel].map((label,index) => {
          const tab = document.createElement('button');
          tab.type = 'button';
          tab.setAttribute('role','tab');
          tab.id = `${table.id}-tab-${index}`;
          tab.textContent = label;
          nav.append(tab);
          return tab;
        });
        wrap.id = `${table.id}-details`;
        wrap.setAttribute('role','tabpanel');
        overview.setAttribute('aria-labelledby',tabs[0].id);
        wrap.setAttribute('aria-labelledby',tabs[1].id);
        tabs[0].setAttribute('aria-controls',overview.id);
        tabs[1].setAttribute('aria-controls',wrap.id);
        const activate = index => {
          card.dataset.activeTab = index === 0 ? 'overview' : 'details';
          card._asActiveTab = card.dataset.activeTab;
          overview.hidden = index !== 0;
          wrap.hidden = index !== 1;
          tabs.forEach((tab,position) => {
            tab.setAttribute('aria-selected',String(position === index));
            tab.tabIndex = position === index ? 0 : -1;
          });
          this.syncCollapse();
        };
        tabs.forEach((tab,index) => {
          tab.addEventListener('click',() => activate(index));
          tab.addEventListener('keydown',event => {
            if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
            event.preventDefault();
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : 1 - index;
            activate(next);
            tabs[next].focus();
          });
        });
        wrap.before(nav,overview);
        activate((card._asActiveTab || this.dataset.defaultTab || 'overview') === 'details' ? 1 : 0);
      }
    }

    findLeadingTitle(source) {
      let node = source.firstElementChild;
      while (node?.matches('div, section') && !node.matches('.as-card') && node.firstElementChild) node = node.firstElementChild;
      if (!node || node.closest('.as-card') || !node.matches('p, h1, h2, h3, h4, h5, h6')) return null;
      if (node.querySelector(`a, ${richOrInteractive}`)) return null;
      if (node.matches('p') && !node.querySelector('strong, b') && !specHeading.test(node.textContent)) return null;
      const lines = plainLines(node);
      if (lines.length !== 1 || lines[0].length > 240 || linePair(lines[0])) return null;
      return {node, text: node.textContent.trim(), used: false};
    }

    card(originalHeading = '', matrix = null) {
      const card = document.createElement('section');
      card.className = 'as-card';
      const title = this.dataset.heading || originalHeading;
      if (title) {
        const header = document.createElement('header');
        header.className = 'as-header';
        const heading = document.createElement('h2');
        heading.className = 'as-title';
        heading.textContent = title;
        header.append(heading);
        card.append(header);
      }
      const table = document.createElement('table');
      table.className = 'as-table';
      const caption = document.createElement('caption');
      caption.className = 'as-sr-only';
      caption.textContent = originalHeading || title;
      const columns = document.createElement('colgroup');
      const labelColumn = document.createElement('col');
      labelColumn.className = 'as-label-column';
      columns.append(labelColumn);
      for (let i = 0; i < (matrix?.columns.length || 1); i++) columns.append(document.createElement('col'));
      table.append(caption, columns, document.createElement('tbody'));
      const wrap = document.createElement('div');
      wrap.className = 'as-table-wrap';
      if (matrix) {
        table.classList.add('as-table--matrix');
        wrap.classList.add('as-table-wrap--matrix');
        wrap.tabIndex = 0;
        wrap.setAttribute('role', 'region');
        if (title) wrap.setAttribute('aria-label', title);
      }
      wrap.append(table);
      card.append(wrap);
      return { card, body: table.tBodies[0] };
    }

    transformTable(table, data, leadingTitle) {
      const leading = leadingTitle && !leadingTitle.used ? leadingTitle : null;
      const { card, body } = this.card(leading?.text || data.heading.trim(), data.matrix);
      if (leading && table.caption && data.heading.trim() !== leading.text) {
        const note = body.insertRow().insertCell();
        note.colSpan = 1 + (data.matrix?.columns.length || 1);
        note.className = 'as-note';
        appendContents(note, table.caption);
      }
      let count = 0;
      data.rows.forEach((row, index) => {
        const cells = [...row.cells];
        if (!cells.length) return;
        if (row === data.titleRow && (!leading || leading.text === data.heading.trim())) return;
        const output = document.createElement('tr');
        if (row === data.matrix?.header) {
          output.className = 'as-matrix-heading';
          for (const source of [cells[0], ...data.matrix.columns.map(column => column.cell)]) {
            const cell = document.createElement('th');
            cell.scope = 'col';
            appendContents(cell, source);
            output.append(cell);
          }
          body.append(output);
          return;
        }
        if (cells.length === 1) {
          const cell = document.createElement('td');
          cell.colSpan = 1 + (data.matrix?.columns.length || 1);
          cell.className = 'as-note';
          appendContents(cell, cells[0]);
          output.append(cell);
        } else {
          const label = document.createElement('th');
          label.scope = 'row';
          appendContents(label, cells[0]);
          output.append(label);
          let groups = [{valueGroups: row.valueGroups, span: data.matrix?.columns.length || 1}];
          if (data.matrix) {
            const kinds = row.valueGroups.flat().map(measureKind);
            const independentMeasures = isColorLabel(data.matrix.header.cells[0].textContent) && kinds.length > 1 && kinds.every(Boolean) && new Set(kinds).size === kinds.length && row.valueGroups.flat().some(cell => data.matrix.columns.every(column => normalized(cell.textContent).includes(normalized(column.cell.textContent))));
            const columns = data.matrix.columns.map(column => ({
              valueGroups: row.grids.map(grid => [...new Set(grid.slice(column.start, column.end))]), span: 1
            }));
            const shared = columns.every(column => column.valueGroups.every((values, index) => values.length === columns[0].valueGroups[index].length && values.every((cell, pos) => cell === columns[0].valueGroups[index][pos])));
            if (!shared && !independentMeasures) groups = columns;
          }
          groups.forEach(group => {
            const value = document.createElement('td');
            value.colSpan = group.span;
            group.valueGroups.forEach(cells => {
              const valueGroup = document.createElement('div');
              valueGroup.className = 'as-value-group';
              cells.forEach(cell => {
                const part = document.createElement('div');
                part.className = 'as-value-part';
                appendContents(part, cell);
                valueGroup.append(part);
              });
              value.append(valueGroup);
            });
            output.append(value);
          });
          count++;
        }
        body.append(output);
      });
      card.dataset.rows = String(count);
      table.replaceWith(card);
      if (leading) { leading.node.remove(); leading.used = true; }
    }

    transformLegacyLines(source, leadingTitle) {
      const candidates = new Set([...source.querySelectorAll('p, li, div')].filter(node =>
        !node.id && !node.closest('table, .as-card') && !node.querySelector(`[id], p, li, div, ul, ol, table, h1, h2, h3, h4, h5, h6, a, ${richOrInteractive}`)
      ));
      for (const first of candidates) {
        if (!first.isConnected) continue;
        const firstLine = plainLines(first)[0] || '';
        if (!legacyPrefix.test(firstLine) || !linePair(firstLine.replace(legacyPrefix, ''))) continue;
        const headingSpacers = [];
        let headingNode = previousPlainSibling(first);
        while (headingNode && candidates.has(headingNode) && !plainLines(headingNode).length) {
          headingSpacers.push(headingNode);
          headingNode = previousPlainSibling(headingNode);
        }
        const headingLines = headingNode ? plainLines(headingNode) : [];
        const hasHeading = headingNode?.matches('p, div, h1, h2, h3, h4, h5, h6')
          && !headingNode.id
          && !headingNode.querySelector(`[id], p, li, div, ul, ol, table, h1, h2, h3, h4, h5, h6, a, ${richOrInteractive}`)
          && headingLines.length === 1 && headingLines[0].length <= 240
          && legacyHeading(headingLines[0]) && !linePair(headingLines[0]);
        const leading = hasHeading ? (headingNode === leadingTitle?.node
          ? leadingTitle : {node: headingNode, text: headingNode.textContent.trim(), used: false}) : null;
        // Asterisks also mark editorial notices; require an explicit adjacent spec heading.
        if (/^\*/.test(firstLine) && !leading) continue;
        const run = [];
        let entries = [];
        let current = first;
        while (current && candidates.has(current)) {
          const lines = plainLines(current);
          if (!lines.length) {
            run.push(current);
            current = nextPlainSibling(current);
            continue;
          }
          // Plan the whole element before consuming it, including any <br> lines.
          const trial = entries.map(entry => ({...entry, continuations: [...(entry.continuations || [])]}));
          let accepted = lines.length > 0;
          for (const line of lines) {
            if (/^\*/.test(line) && !leading) { accepted = false; break; }
            const prefixed = legacyPrefix.test(line);
            const text = prefixed ? line.replace(legacyPrefix, '') : line;
            const pair = prefixed ? linePair(text) : null;
            if (pair && legacyKnown(pair.label)) {
              trial.push({...pair, kind: 'pair', continuations: []});
            } else if (leading && trial.filter(entry => entry.kind === 'pair' && legacyKnown(entry.label)).length >= 2
              && prefixed && legacyEmulatorNote(text)) {
              // A legacy feature sentence has no label; keep it as a full-width note.
              trial.push({kind: 'note', text, continuations: []});
            } else if (leading && ((!prefixed && legacyNoteContinuation(trial[trial.length - 1], text))
              || legacyContinuation(trial[trial.length - 1], text))) {
              trial[trial.length - 1].continuations.push(text);
            } else {
              accepted = false;
              break;
            }
          }
          if (!accepted) break;
          entries = trial;
          run.push(current);
          current = nextPlainSibling(current);
        }
        const pairs = entries.filter(entry => entry.kind === 'pair');
        if (pairs.filter(pair => legacyKnown(pair.label)).length < 2) continue;
        const {card, body} = this.card(leading?.text || '');
        for (const entry of entries) {
          const row = document.createElement('tr');
          if (entry.kind === 'note') {
            const note = document.createElement('td');
            note.colSpan = 2;
            note.className = 'as-note';
            note.textContent = entry.text;
            for (const continuation of entry.continuations) {
              note.append(document.createElement('br'), document.createTextNode(`\n${continuation}`));
            }
            row.append(note);
          } else {
            const label = document.createElement('th');
            label.scope = 'row';
            label.textContent = entry.label;
            const value = document.createElement('td');
            value.textContent = entry.value;
            for (const continuation of entry.continuations) {
              value.append(document.createElement('br'), document.createTextNode(`\n${continuation}`));
            }
            row.append(label, value);
          }
          body.append(row);
        }
        card.dataset.rows = String(pairs.length);
        if (first.tagName === 'LI') {
          const item = document.createElement('li');
          item.className = 'as-list-card';
          item.append(card);
          first.before(item);
        } else first.before(card);
        run.forEach(node => node.remove());
        if (leading) {
          leading.node.remove();
          headingSpacers.forEach(node => node.remove());
          leading.used = true;
        }
      }
    }

    transformLines(source, leadingTitle) {
      this.transformLegacyLines(source, leadingTitle);
      const candidates = [...source.querySelectorAll('p, li, div')].filter(node =>
        !node.id && !node.closest('table, .as-card') && !node.querySelector(`[id], p, li, div, ul, ol, table, h1, h2, h3, h4, h5, h6, a, ${richOrInteractive}`)
      );
      const processed = new Set();
      for (const first of candidates) {
        if (processed.has(first) || !first.isConnected) continue;
        const run = [];
        let current = first;
        while (current && candidates.includes(current) && !processed.has(current)) {
          const lines = plainLines(current);
          const pairs = lines.map(linePair);
          if (!pairs.length || pairs.some(pair => !pair)) break;
          run.push({ node: current, pairs });
          processed.add(current);
          const sibling = current.nextElementSibling;
          let between = current.nextSibling;
          let hasText = false;
          while (between && between !== sibling) {
            if (between.nodeType === Node.TEXT_NODE && between.textContent.trim()) hasText = true;
            between = between.nextSibling;
          }
          if (hasText) break;
          current = sibling;
        }
        const all = run.flatMap(item => item.pairs);
        const knownPairs = all.filter(pair => known(pair.label)).length;
        const valuePairs = all.filter(pair => valueKind(pair.value)).length;
        if (knownPairs < 2 && valuePairs < 3) continue;
        const leading = leadingTitle && !leadingTitle.used ? leadingTitle : null;
        const { card, body } = this.card(leading?.text || '');
        for (const pair of all) {
          const row = document.createElement('tr');
          const label = document.createElement('th');
          label.scope = 'row';
          label.textContent = pair.label;
          const value = document.createElement('td');
          value.textContent = pair.value;
          row.append(label, value);
          body.append(row);
        }
        card.dataset.rows = String(all.length);
        if (first.tagName === 'LI') {
          const item = document.createElement('li');
          item.className = 'as-list-card';
          item.append(card);
          first.before(item);
        } else first.before(card);
        run.forEach(item => item.node.remove());
        if (leading) { leading.node.remove(); leading.used = true; }
      }
    }

    enhance() {
      const source = this.querySelector('[data-as-source]');
      this.observer?.disconnect();
      try {
        if (source) {
          const leadingTitle = this.findLeadingTitle(source);
          const tables = [...source.querySelectorAll('table')].filter(table => !table.closest('.as-card') && !table.parentElement.closest('table'));
          for (const table of tables) {
            const data = tableData(table);
            if (data) this.transformTable(table, data, leadingTitle);
          }
          this.transformLines(source, leadingTitle);
          this.syncPresentation();
          this.syncCollapse();
          this.dataset.enhanced = String(source.querySelectorAll('.as-card').length);
        }
      } finally {
        if (this.isConnected) this.observer?.observe(this, { childList: true, subtree: true, characterData: true });
      }
    }
  }

  customElements.define(tag, AutoSpecs);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const resetCascadeMenu = (menu) => {
    if (!menu) return;

    menu.classList.remove('is-expanded');
    menu.style.setProperty('--cascade-shift-x', '0px');
    menu.style.setProperty('--cascade-panel-top', '0.8rem');

    menu.querySelectorAll('[data-cascade-trigger]').forEach((trigger) => {
      trigger.classList.remove('is-active');
      trigger.setAttribute('aria-expanded', 'false');
    });

    menu.querySelectorAll('[data-cascade-panel]').forEach((panel) => {
      panel.hidden = true;
    });
  };

  const positionCascadePanel = (menu, trigger) => {
    if (!menu || !trigger) return;

    const primary = menu.querySelector('.cascade-dropdown__primary');
    if (!primary) return;

    /* Align the top edge of the right panel with the selected row. */
    const top = trigger.offsetTop;
    menu.style.setProperty('--cascade-panel-top', `${Math.round(top)}px`);
  };

  const fitCascadeMenuToViewport = (menu) => {
    if (!menu || window.innerWidth < 1280) return;

    menu.style.setProperty('--cascade-shift-x', '0px');

    requestAnimationFrame(() => {
      const gutter = 16;
      const menuRect = menu.getBoundingClientRect();
      const secondary = menu.querySelector('[data-cascade-secondary]');
      const secondaryRect = menu.classList.contains('is-expanded') && secondary
        ? secondary.getBoundingClientRect()
        : null;

      let left = menuRect.left;
      let right = menuRect.right;

      if (secondaryRect) {
        left = Math.min(left, secondaryRect.left);
        right = Math.max(right, secondaryRect.right);
      }

      let shift = 0;

      if (right > window.innerWidth - gutter) {
        shift -= right - (window.innerWidth - gutter);
      }

      if (left + shift < gutter) {
        shift += gutter - (left + shift);
      }

      menu.style.setProperty('--cascade-shift-x', `${Math.round(shift)}px`);
    });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cascade-trigger]');

    if (trigger) {
      const menu = trigger.closest('[data-cascade-menu]');
      if (!menu) return;

      event.preventDefault();

      const targetId = trigger.getAttribute('data-cascade-target');
      const targetPanel = Array.from(menu.querySelectorAll('[data-cascade-panel]')).find(
        (panel) => panel.id === targetId
      );
      const alreadyOpen = trigger.getAttribute('aria-expanded') === 'true';

      resetCascadeMenu(menu);

      if (!alreadyOpen && targetPanel) {
        trigger.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
        targetPanel.hidden = false;
        positionCascadePanel(menu, trigger);
        menu.classList.add('is-expanded');
        fitCascadeMenuToViewport(menu);
      }

      return;
    }

    const summary = event.target.closest('.cascade-nav summary');
    if (summary) {
      const details = summary.closest('details');

      /* Keep the dropdown open when the customer clicks elsewhere on the page.
         Only close another top-level dropdown when a different top-level menu is opened. */
      document.querySelectorAll('.cascade-nav [data-static-header-menu] > details[open]').forEach((openDetails) => {
        if (openDetails !== details) {
          openDetails.open = false;
          resetCascadeMenu(openDetails.querySelector('[data-cascade-menu]'));
        }
      });

      window.setTimeout(() => {
        if (details && !details.open) {
          resetCascadeMenu(details.querySelector('[data-cascade-menu]'));
        } else if (details?.open) {
          fitCascadeMenuToViewport(details.querySelector('[data-cascade-menu]'));
        }
      }, 0);
    }
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('[data-cascade-menu].is-expanded').forEach((menu) => {
      fitCascadeMenuToViewport(menu);
    });
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());

      this.header.querySelectorAll('[data-static-header-menu] > details[open]').forEach((details) => {
        details.open = false;
        resetCascadeMenu(details.querySelector('[data-cascade-menu]'));
      });
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
